module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "question-edit"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isEditMode),
      expression: "!isEditMode"
    }],
    ref: "text",
    staticClass: "title",
    attrs: {
      "id": "q-readonly"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$sanitize(_vm.title))
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEditMode),
      expression: "isEditMode"
    }],
    ref: "editor",
    staticClass: "title",
    attrs: {
      "id": "q-editor"
    }
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (!_vm.isEditMode) ? _c('mu-icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.bottom",
      value: ('Edit'),
      expression: "'Edit'",
      modifiers: {
        "bottom": true
      }
    }],
    staticClass: "editIcon",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "size": 22,
      "value": "edit",
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editMode.apply(null, arguments)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isEditMode) ? _c('div', {
    staticClass: "bottom"
  }, [_c('mu-flat-button', {
    attrs: {
      "label": _vm.$t('message.cancelText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancel.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "secondary": "",
      "label": _vm.$t('message.saveText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.updateQuestion.apply(null, arguments)
      }
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eb3794a6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Questions/EditQuestionTitle/EditQuestionTitle.vue
// module id = 3310
// module chunks = 1